import React from 'react';

function ArrowRight({
  width = '1rem',
  style,
  viewBox = '0 0 24 24',
  className,
  fill = '#fff',
}) {
  return (
    <svg
      width={width}
      style={style}
      height={width}
      viewBox={viewBox}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.914 8.0865c-.391-.391-.391-1.023 0-1.414s1.024-.391 1.414 0l4.122 4.121c.781.781.781 2.047 0 2.828l-4.122 4.121c-.39.391-1.023.391-1.414 0-.391-.39-.391-1.023 0-1.414l4.121-4.121-4.121-4.121z"
        fill={fill}
        fillRule="nonzero"
      />
    </svg>
  );
}

export default ArrowRight;
